import gql from 'graphql-tag';
import { AssetImageSubtype } from 'src/modules/assets';
import { getOutputChannel } from 'src/modules/locale/components/Provider/outputChannel';

export const QUERY_PROFESSIONALS_DOWNLOADS_PRODUCTS_FILTER_DATA = gql`
  query DownloadsProductsData {
    productCategories: searchProductCategories {
      id
      name_en
      name_de
      slug
    }
    locationTypes: searchLocationTypes(where: { key_null: false, pim_key_null: true }) {
      id
      name_en
      name_de
      slug
    }
  }
`;

export const QUERY_PROFESSIONALS_DOWNLOADS_PRODUCTS_SEARCH = gql`
  query DownloadsProducts(
    $term: String!
    $categoryIds: [String]
    $categorySlug: String
    $subcategoryIds: [String]
    $locationTypeIds: [String]!
    $designerIds: [String]
    $locale: String!
    $limit: Int!
    $offset: Int!
    $sortColumn: String
    $sortDirection: String
    $outputChannel: String
  ) {
    productsSearch(
      limit: $limit
      offset: $offset
      locale: $locale
      sortColumn: $sortColumn
      sortDirection: $sortDirection
      where: {
        term: $term
        categorySlug: $categorySlug
        categoryIds: $categoryIds
        subcategoryIds: $subcategoryIds
        locationTypeIds: $locationTypeIds
        designerIds: $designerIds
        outputChannel: $outputChannel
      }
    ) {
      id
      name_en
      name_de
      pim_id
      slug
      channels
      assets(where: { type: "image", subtype: "${AssetImageSubtype.Cutout}" }, sort: "sorting:asc", limit: 1) {
        type
        subtype
        file {
          url
          formats
        }
      }
      product_series {
        id
        name_en
        name_de
        designer {
          id
          name
        }
      }
      product_categories {
        id
        slug
      }
      location_types {
        id
        slug
      }
    }
    searchResultsCount(
      locale: $locale
      where: {
        term: $term
        categoryIds: $categoryIds
        categorySlug: $categorySlug
        subcategoryIds: $subcategoryIds
        locationTypeIds: $locationTypeIds
        designerIds: $designerIds
        outputChannel: $outputChannel
      }
    )
  }
`;

export const QUERY_PROFESSIONALS_DOWNLOADS_PRODUCT_DETAILS = gql`
  query DownloadsProductDetails(
    $slug: String!
    $outputChannel: String! = "de_DE"
    $mediaOutputChannel: String! = "de_DE_media"
  ) {
    products(where: { slug: $slug, channels_in: $outputChannel }, limit: 1) {
      id
      name_en
      name_de
      slug
      assets(where: { channels_in: $mediaOutputChannel }, sort: "sorting:asc") {
        id
        type
        subtype
        channels
        file {
          id
          url
          formats
          name
          caption
          alternativeText
          ext
          mime
          width
          height
          size
        }
      }
      product_series {
        name_en
        name_de
      }
    }
  }
`;

export const QUERY_PROFESSIONALS_DOWNLOADS_PATHS = gql`
  query ProfessionalsDownloadsProductsPaths(
    $limit: Int!
    $offset: Int!
  ){
    productsSearch(limit: $limit, offset: $offset, where: { term: "", outputChannel: "${getOutputChannel()}" }) {
      slug
      name_en
      name_de
    }
    searchResultsCount(where: { term: "", outputChannel: "${getOutputChannel()}" })
  }
`;
